<template>
  <span
    v-tooltip="setContextTooltip"
    @click.stop="showSetContext = !showSetContext"
  >
    <slot :toggle-menu="toggle">
      <icon-base
        :icon="context ? IconEdit : IconWarning"
        :icon-color="context ? UTIL_COLORS.DEFAULT : UTIL_COLORS.WARNING"
        class="cursor-pointer"
        data-cy="set-score-model-context"
        @click.stop="toggle"
      />
    </slot>
  </span>
  <div v-if="showSetContext" ref="scoreModelPickerRef" class="z-30 min-w-50">
    <score-model-picker :attribute-id="attributeId" @apply="applyContext" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import { UTIL_COLORS } from "@/helpers/constants";
import { useTeleportV2 } from "@/hooks/elements";

import ScoreModelPicker from "@/components/customAttributes/formula/ScoreModelPicker.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconWarning from "@/components/icons/IconWarning.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { BOP_CONSUMER_SCORE_MODELS } from "@/helpers/constants/experian";
import type { IContextSetValueModel } from "@/models/orchestration";

const emit = defineEmits<{
  (event: "apply", value: IContextSetValueModel): void;
}>();

const { context, attributeId } = defineProps<{
  context?: IContextSetValueModel;
  attributeId?: string;
}>();

const { t } = useI18n();
const showSetContext = ref(false);
const scoreModelPickerRef = ref<HTMLElement | null>(null);

useTeleportV2({
  target: scoreModelPickerRef,
  to: "#menus",
  offset: { top: 5 },
  checkForOverflow: true,
});

const setContextTooltip = computed(() => {
  return `${t("COMMON.SET")} ${t("SCORECARDS.SCORE_MODEL")}`;
});

const toggle = () => {
  showSetContext.value = !showSetContext.value;
};

const applyContext = (value: keyof typeof BOP_CONSUMER_SCORE_MODELS) => {
  const context: IContextSetValueModel = {
    type: "consumer_score_models_levels",
    value: {
      level: value,
    },
  };
  emit("apply", context);
  showSetContext.value = false;
};
</script>
